  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-delivery-submit]');
    if (!button) return;
    var panel = button.closest('[data-delivery-check]');
    var field = panel.querySelector('[data-delivery-postcode]');
    var status = panel.querySelector('[data-delivery-status]');
    var zip = field.value.trim();
    if (!zip) { status.textContent = panel.dataset.missing; field.focus(); return; }
    button.disabled = true;
    status.textContent = panel.dataset.loading;
    var root = panel.dataset.root.replace(/\/$/, '') + '/';
    var params = new URLSearchParams({ 'shipping_address[zip]': zip, 'shipping_address[country]': panel.dataset.country });
    try {
      var request = await fetch(root + 'cart/prepare_shipping_rates.json?' + params, { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
      if (!request.ok) throw new Error('rates');
      var result = null;
      for (var attempt = 0; attempt < 10; attempt++) {
        await new Promise(function (resolve) { setTimeout(resolve, 800); });
        var response = await fetch(root + 'cart/async_shipping_rates.json?' + params, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
        if (!response.ok) throw new Error('rates');
        result = await response.json();
        if (result !== null) break;
      }
      if (!result || !Array.isArray(result.shipping_rates)) throw new Error('rates');
      status.textContent = result.shipping_rates.length ? panel.dataset.available : panel.dataset.unavailable;
    } catch (error) { status.textContent = panel.dataset.error; }
    finally { button.disabled = false; }
  });
  document.addEventListener('input', function (event) {
    if (event.target.matches('[data-delivery-postcode]')) event.target.closest('[data-delivery-check]').querySelector('[data-delivery-status]').textContent = '';
  });
